import React from "react";
import { CORONAVIRUS_PAGE_ID } from "../constants";
import SequencesPageDefaultTemplate from "./Default";
import SequencesPageCoronavirusTemplate from "./Coronavirus";

const SequencesPageTemplate = ({ typePage, ...props }) => {
	const Template =
		typePage === CORONAVIRUS_PAGE_ID
			? SequencesPageCoronavirusTemplate
			: SequencesPageDefaultTemplate;

	return <Template {...props} />;
};

export default SequencesPageTemplate;
